import {useFindAllGroups} from "hooks/query/group-query"
import SortableTree, {defaultSearchMethod} from "react-sortable-tree"
import {TreeNodeData} from "pages/group/GroupListView"
import {useEffect, useState} from "react"
import {Group} from "dto/Group"
import {convertGroupToTreeData} from "pages/group/GroupTree"
import {useAssignToGroup, useFindGroupsIncludingUser, useLeaveGroup} from "hooks/query/user-query"
import {useParams} from "react-router-dom"
import {NotificationType, showNotification} from "common/Notification"

const maxHeight = 400

export function UpdateUserGroup() {
    const {id} = useParams()
    const {data: groups} = useFindAllGroups()
    const {data: userGroups} = useFindGroupsIncludingUser(id)
    const [treeData, setTreeData] = useState<TreeNodeData[]>()
    const [selectedNode, selectNode] = useState<TreeNodeData | undefined>()
    const [selectedUserGroup, selectUserGroup] = useState<Group | undefined>()
    const assignToGroupMutate = useAssignToGroup()
    const leaveGroupMutate = useLeaveGroup()
    useEffect(() => {
        const groupData: Group[] = [{
            name: "그룹",
            subGroups: groups
        }]
        setTreeData(groupData.map(group => convertGroupToTreeData(group)))
    }, [groups])

    const assignToGroup = () => {
        if (!id) {
            showNotification("추가할 사용자가 선택되지 않았습니다")
            return
        }
        if (!selectedNode) {
            showNotification("추가할 그룹이 선택되지 않았습니다")
            return
        }
        assignToGroupMutate.mutate({id: id, groupId: selectedNode.id}, {
            onSuccess: () => {
                showNotification("그룹이 추가되었습니다", NotificationType.SUCCESS)
                selectNode(undefined)
                selectUserGroup(undefined)
            },
            onError: () => showNotification("그룹을 추가하지 못했습니다")
        })
    }

    const leaveGroup = () => {
        if (!id) {
            showNotification("추가할 사용자가 선택되지 않았습니다")
            return
        }
        if (!selectedUserGroup || !selectedUserGroup.id) {
            showNotification("삭제할 그룹이 선택되지 않았습니다")
            return
        }
        leaveGroupMutate.mutate({id, groupId: selectedUserGroup.id}, {
            onSuccess: () => {
                showNotification("그룹을 삭제하였습니다", NotificationType.SUCCESS)
                selectNode(undefined)
                selectUserGroup(undefined)
            },
            onError: () => showNotification("그룹을 삭제하지 못했습니다")
        })
    }
    if (!treeData) return null
    return (

        <div className="columns mt20">
            <div className="column">
                <div className=" ml20">
                    <div className="gray-label is-size-85">그룹리스트</div>
                    <div className="">
                        <div className="panel-02 border-solid border overflow-y-auto" style={{height: maxHeight}}>
                            <SortableTree treeData={treeData}
                                          onChange={(changedData) => {
                                              console.log("treedata : ", changedData)
                                              setTreeData([...changedData])
                                          }}
                                          getNodeKey={({node}) => (`${node.id}/${node.title}`)}
                                          isVirtualized={false} canDrag={false} slideRegionSize={30}
                                // onVisibilityToggle={(data) => {
                                // }}
                                          generateNodeProps={({node, path, isSearchMatch}) => {
                                              // console.log("path: ", path, isSearchMatch)
                                              return {
                                                  id: node.id,
                                                  style: {
                                                      backgroundColor: '#EFEFEF'
                                                  },
                                                  onClick: (e: Event, data: TreeNodeData) => {
                                                      selectNode(node)
                                                  },
                                                  title: <div
                                                      className={isSearchMatch ? "text-pink-500" : selectedNode?.id === node.id ? `text-amber-600` : ""}>{node.title}</div>,
                                              }
                                          }}
                                          rowHeight={50}
                            />

                        </div>
                    </div>
                    <div className="mt10">
                        <button className="button is-primary  is-size-85" onClick={() => assignToGroup()}>
                            <span>추가</span>
                            <span className="icon">
                                <i className="fa-solid fa-angles-right"></i>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
            <div className="column">
                <div className=" ml20">
                    <div className="gray-label is-size-85">그룹 멤버쉽</div>
                    <div className="">
                        <div className="panel-02 border-solid border overflow-y-auto p-3" style={{height: maxHeight}}>
                            <div className="panel-box">
                                {userGroups?.map(group => {
                                    return (
                                        <div key={group.id} className="panel-02-block first:border"
                                             onClick={() => selectUserGroup(group)}
                                        >
                                            <div
                                                className={`is-clickable ${selectedUserGroup?.id === group.id ? "text-amber-600" : ""}`}>
                                                <span><i className="fa-solid fa-folder"></i></span>
                                                <span className="ml-4">{group.path}</span>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="mt10">
                        <button className="button is-dark is-size-85" onClick={() => leaveGroup()}>
                            <span className="icon">
                                <i className="fa-solid fa-angles-left"></i>
                            </span>
                            <span>삭제</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

    )
}